  function ensureReopen() {
    if (reopenEl && document.body.contains(reopenEl)) return reopenEl;
    reopenEl = document.createElement('button');
    reopenEl.type = 'button';
    reopenEl.className = 'muster-reopen';
    reopenEl.setAttribute('aria-label', 'Muster-Auswahl öffnen');
    reopenEl.innerHTML = '<img class="muster-reopen__ico" src="' + HEADER_ICON_URL + '" alt="" aria-hidden="true"><span class="muster-reopen__txt"></span>';
    reopenEl.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      openModal(); // Header-Button -> großes Musterpaket-Modal
    });
    var cart = document.querySelector('#cart-icon-bubble, a.cart-drawer-button, cart-drawer-button, a[href="/cart"], a[href$="/cart"], .header__icon--cart, [data-cart-icon], cart-drawer-toggle, .js-cart-trigger, .header-cart, .site-header__cart');
    var group = cart && cart.parentNode;
    if (group) {
      group.insertBefore(reopenEl, group.firstChild); // ganz links, vor allen Header-Icons
    } else {
      reopenEl.classList.add('muster-reopen--float'); // Fallback: schwebend oben rechts
      document.body.appendChild(reopenEl);
    }
    return reopenEl;
  }
  function updateReopen() {
    var el = ensureReopen();
    if (!el) return;
    var n = count();
    var txt = el.querySelector('.muster-reopen__txt') || el;
    txt.textContent = n + ' / ' + MAX + ' Muster';
    el.classList.toggle('is-visible', n > 0); // dauerhaft sichtbar, sobald ein Muster gewählt ist
  }

  // ---- Großes Modal "Dein Musterpaket" ----
  var modalEl, modalOpen = false, modalSig = null;
  // Kürzt den Produktnamen für die Kachel: Kategorie-Präfix + Maße entfernen.
  var LABEL_PREFIXES = [
    'SPC-Wandverkleidung', 'WPC-Wandverkleidung', 'WPC-Hohlkammer Basic', 'WPC-Hohlkammer',
    'WPC-Massivdiele Antik', 'WPC-Massivdiele ECO', 'WPC-Massivdiele Terra', 'WPC-Massivdiele',
    'WPC-Terrassendiele', 'Akustikpaneele', 'Akustikpaneel', 'Terrassenplatte', 'Terrassendiele'
  ];
  function cleanLabel(name) {
    if (!name) return '';
    var s = String(name).trim().replace(/^muster\s+/i, '');
    for (var i = 0; i < LABEL_PREFIXES.length; i++) {
      var re = new RegExp('^' + LABEL_PREFIXES[i].replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&') + '\\s+', 'i');
      if (re.test(s)) { s = s.replace(re, ''); break; }
    }
    // Maße am Ende entfernen, z. B. "244 × 60 cm" oder "244 x 60 x 5 cm"
    s = s.replace(/\s*\d+\s*[×x]\s*\d+(\s*[×x]\s*\d+)?\s*(cm|mm)?\s*$/i, '');
    return s.trim();
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var ICON_X_SM = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  function ensureModal() {
    if (modalEl && document.body.contains(modalEl)) return modalEl;
    modalEl = document.createElement('div');
    modalEl.className = 'muster-modal';
    modalEl.innerHTML = '<div class="muster-modal__backdrop"></div><div class="muster-modal__card" role="dialog" aria-modal="true" aria-label="Dein Musterpaket"></div>';
    document.body.appendChild(modalEl);
    modalEl.querySelector('.muster-modal__backdrop').addEventListener('click', closeModal);
    return modalEl;
  }
  function benefitsHtml() {
    if (!BENEFITS || !BENEFITS.length) return '';
    var rows = '';
    for (var i = 0; i < BENEFITS.length; i++) {
      rows += '<li class="muster-modal__benefit">' +
        '<img class="muster-modal__benefit-ico" src="' + esc(BENEFITS[i].icon) + '" alt="" aria-hidden="true">' +
        '<span>' + esc(BENEFITS[i].text) + '</span></li>';
    }
    return '<ul class="muster-modal__benefits">' + rows + '</ul>';
  }
  function contactHtml() {
    if (!CONTACT || CONTACT.enable === false) return '';
    var name = CONTACT.name || '';
    var role = CONTACT.role || 'Wir unterstützen dich bei deinem Projekt.';
    if (role) { role = String(role).trim(); if (!/[.!?…]$/.test(role)) role += '.'; }
    var phone = CONTACT.phone || '';
    var email = CONTACT.email || '';
    var wa = CONTACT.whatsapp || '';
    var img = CONTACT.image || CONTACT_IMG_DEFAULT;
    if (!name && !phone && !email && !wa && !img) return '';
    var initial = name ? esc(name.trim().charAt(0).toUpperCase()) : 'M';
    var photo = img
      ? '<div class="muster-modal__contact-photo-col"><img class="muster-modal__contact-photo" src="' + esc(img) + '" alt="' + esc(name) + '"></div>'
      : '<div class="muster-modal__contact-photo-col"><span class="muster-modal__contact-photo">' + initial + '</span></div>';
    var links = '';
    var icoPhone = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.6 10.8a15 15 0 0 0 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1A17 17 0 0 1 3 4c0-.6.4-1 1-1h3.4c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.4 0 .8-.3 1.1z" fill="currentColor"/></svg>';
    var icoMail = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm8 7L4.5 7h15z" fill="currentColor"/></svg>';
    var icoWa = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15l-1.3 4.8 4.9-1.3A10 10 0 1 0 12 2zm0 18a8 8 0 0 1-4.1-1.1l-.3-.2-2.9.8.8-2.8-.2-.3A8 8 0 1 1 12 20zm4.4-5.9c-.2-.1-1.4-.7-1.6-.8s-.4-.1-.5.1-.6.8-.8 1-.3.1-.5 0a6.5 6.5 0 0 1-3.2-2.8c-.2-.4.2-.4.6-1.2.1-.2 0-.3 0-.5l-.7-1.7c-.2-.5-.4-.4-.5-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.6 4c2 .8 2 .5 2.3.5a2.6 2.6 0 0 0 1.8-1.2 2.2 2.2 0 0 0 .1-1.2c-.1-.1-.2-.1-.4-.2z" fill="currentColor"/></svg>';
    if (phone) links += '<a class="muster-modal__contact-link" href="tel:' + esc(phone.replace(/\s+/g, '')) + '">' + icoPhone + esc(phone) + '</a>';
    if (email) links += '<a class="muster-modal__contact-link" href="mailto:' + esc(email) + '">' + icoMail + esc(email) + '</a>';
    if (wa) links += '<a class="muster-modal__contact-link" href="https://wa.me/' + esc(wa.replace(/[^0-9]/g, '')) + '" target="_blank" rel="noopener">' + icoWa + esc(wa) + '</a>';
    return '<div class="muster-modal__contact">' + photo +
      '<div class="muster-modal__contact-main">' + benefitsHtml() +
      (name ? '<div class="muster-modal__contact-name">' + esc(name) + '</div>' : '') +
      (role ? '<div class="muster-modal__contact-role">Du hast offene Fragen?<br>' + esc(role) + '</div>' : '') +
      '<div class="muster-modal__contact-links">' + links + '</div></div></div>';
  }
  function renderModal() {
    var card = ensureModal().querySelector('.muster-modal__card');
    var n = count();
    var sig = n + '|' + selected.map(function (it) { return it.id + (it.v ? 'v' : ''); }).join(',');
    if (sig === modalSig && card.children.length) return; // kein Rebuild -> kein Flackern
    modalSig = sig;
    var addable = 0, seen = {};
    for (var k = 0; k < selected.length; k++) { var vv = selected[k].v; if (vv && !seen[vv]) { seen[vv] = 1; addable++; } }
    var slots = '';
    for (var i = 0; i < MAX; i++) {
      var it = selected[i];
      if (it) {
        var lbl = (it.label && String(it.label).trim()) ? String(it.label).trim() : cleanLabel(it.name);
        slots += '<div class="muster-modal__slot muster-modal__slot--filled">' +
          (it.img ? '<img src="' + esc(it.img) + '" alt="">' : '') +
          '<button type="button" class="muster-modal__slot-remove" data-muster-id="' + esc(it.id) + '" aria-label="Muster entfernen">' + ICON_X_SM + '</button>' +
          (lbl ? '<span class="muster-modal__slot-label">' + esc(lbl) + '</span>' : '') +
          '</div>';
      } else {
        slots += '<div class="muster-modal__slot muster-modal__slot--empty"></div>';
      }
    }
    var rest = MAX - n;
    var hint = rest > 0
      ? 'Du kannst gerne noch <b>bis zu ' + rest + ' weitere Muster</b> hinzufügen.'
      : '<b>Maximum erreicht</b> – du hast ' + MAX + ' Muster gewählt.';
    card.innerHTML =
      '<button type="button" class="muster-modal__close" aria-label="Schließen">' + ICON_X + '</button>' +
      '<div class="muster-modal__body">' +
      '<h2 class="muster-modal__title">Dein Musterpaket</h2>' +
      '<div class="muster-modal__grid">' + slots + '</div>' +
      '<p class="muster-modal__hint">' + hint + '</p>' +
      '<div class="muster-modal__actions">' +
      '<button type="button" class="muster-modal__cta"' + (addable > 0 ? '' : ' disabled') + '>Kostenlos bestellen' + (addable > 0 ? ' (' + addable + ')' : '') + '</button>' +
      '<button type="button" class="muster-modal__secondary">Weitersuchen</button>' +
      '</div></div>' + contactHtml();
    card.querySelector('.muster-modal__close').addEventListener('click', closeModal);
    card.querySelector('.muster-modal__secondary').addEventListener('click', closeModal);
    var cta = card.querySelector('.muster-modal__cta');
    if (cta) cta.addEventListener('click', function () { if (window.mbOpenQuestions) { window.mbOpenQuestions(); } else { addAllToCart(); } });
    Array.prototype.forEach.call(card.querySelectorAll('.muster-modal__slot-remove'), function (b) {
      b.addEventListener('click', function () {
        removeId(b.getAttribute('data-muster-id'));
        syncAll();
        if (count() === 0) closeModal();
      });
    });
  }
